
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class Slider extends Vue {
  @Prop()
  value!: string;

  @Prop()
  step!: number;

  @Prop()
  min!: number;

  @Prop()
  max!: number;

  listenToRangeSlider = false;

  get sliderStep() {
    if (this.step) {
      return this.step;
    }

    return 1;
  }

  rangeSliderChanged(number: number) {
    /**
     * v-slider emits an @input with the "min/max" value when the value exceeds them
     * That causes any higher or lower value entered in <NumberInput /> to reset to the min/max. We don't want that.
     */
    if (!this.listenToRangeSlider) {
      return;
    }

    if (number.toString() !== this.value) {
      this.$emit("input", number.toString());
    }
  }

  setRangeEnabled(isEnabled = true) {
    this.listenToRangeSlider = isEnabled;
  }
}
